export default `
Your trust is our priority and we are committed to maintaining the highest standards of security and privacy. By using Nurau, you agree that:
- **Anonymization**: All information you provide will be anonymized and processed only to improve our services
- **What we collect**:
  - Name, email, organization, login credentials
  - Device, usage and support data
- **Who can see your data**:
  - Your conversations with Nurau are confidential.
  - They are not shared with your manager or your company
- **How your data is used**:
  - To operate and improve the App
  - To generate AI-assisted workplace guidance and improve your experience on the App. Note that the AI is passive and is a support tool only. It does not make decisions about you or replace human judgment
  - To comply with legal obligations and ensure security
- **Where it may go**:
  - Should information ever be stored or accessed outside Québec, all privacy safeguards will  be in place
- **Your rights**:
  - Access, correct, or delete your data
  - Withdraw consent at any time
  - Contact our Privacy Officer: legal@nurau.com
`;
